import React, {useMemo, useReducer, useRef} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import {postUploadImage} from '../../../apis/image/postUploadImage'
import useNavigation from '../../../hooks/useNavigation'
import WizSelectButton from '../../../components/button/WizSelectButton'
import Text from '../../../components/text/Text'
import UnderLineInput from '../../../components/input/UnderLineInput'
import WizImage from '../../../components/image/WizImage'
import WizButton from '../../../components/button/WizButton'
import {createAdvertisement} from '../../../apis/advertisement/createAdvertisement'

interface IProps {
    className?: string
}
type TBackground = {
    light?: string
    dark?: string
}

const initState = {
    channel: 'ko',
    title: '',
    description: '',
    thumbnail: '',
    url: '',
    is_active: false,
    background: {
        light: '',
        dark: '',
    } as TBackground,
}

const AdvertisementCreatePage: React.FC<IProps> = ({className}) => {
    const {goAdvertisement} = useNavigation()

    const [state, dispatch] = useReducer(reducer, initState)

    const {channel, title, description, thumbnail, url, is_active, background} = state

    function reducer(state, action) {
        switch (action.type) {
            case 'field_update':
                return {...state, [action.field]: action.value}
        }
        return {...state}
    }

    const onChangeThumbnail = async e => {
        const imageFile = e?.target?.files[0]

        if (imageFile) {
            const result = await postUploadImage(imageFile)
            dispatch({type: 'field_update', field: 'thumbnail', value: result?.image_url})
        }
    }

    const channelList = useMemo(
        () => [
            {id: 'ko', value: 'Korean'},
            {id: 'en', value: 'English'},
        ],
        [],
    )

    const activeList = useMemo(
        () => [
            {id: true, value: 'Active'},
            {id: false, value: 'Deactivation'},
        ],
        [],
    )

    const thumbnailRef = useRef<any>()

    const onClickCreateAD = async () => {
        if (!title || !thumbnail) {
            alert('Title 또는 Thumbnail이 비어있습니다.')
            return false
        }

        await createAdvertisement({
            title: title,
            description: description,
            thumbnail: thumbnail,
            pc_url: url,
            mobile_url: url,
            language: channel,
            is_active: is_active,
            type: 'native',
            background,
        }).then(() => {
            alert('Create Complete AD')
            goAdvertisement()
        })
    }

    return (
        <PageLayout title={'Create AD'}>
            <div
                className={
                    'w-[1000px] bg-white rounded-[10px] shadow-normal mx-auto py-[40px] px-[80px] grid grid-cols-2 gap-x-[40px] gap-y-[60px] lg:w-[900px] md:w-[500px] md:px-[20px] sm:w-full sm:block sm:space-y-[20px]'
                }>
                <div className={'space-y-[5px] sm:text-center'}>
                    <Text className={'text-body3 text-font02'}>Channel</Text>
                    <WizSelectButton
                        data={channelList}
                        onChange={e => {
                            dispatch({
                                type: 'field_update',
                                field: 'channel',
                                value: channelList?.find(item => item.id === e.id).id,
                            })
                        }}
                        activeValue={channelList?.find(item => item.id === channel)}
                        className={'sm:mx-auto'}
                    />
                </div>
                <div className={'space-y-[5px] sm:text-center'}>
                    <Text className={'text-body3 text-font02'}>Active</Text>
                    <WizSelectButton
                        data={activeList}
                        onChange={e => {
                            dispatch({
                                type: 'field_update',
                                field: 'is_active',
                                value: activeList?.find(item => item.id === e.id).id,
                            })
                        }}
                        activeValue={activeList?.find(item => item.id === is_active)}
                        className={'sm:mx-auto'}
                    />
                </div>
                <div
                    className={
                        'col-span-2 border rounded-[5px] border-line02 px-[30px] py-[15px] flex space-x-[20px] items-center bg-bg_gray02 md:px-[15px] md:py-[10px]'
                    }>
                    <div>
                        <div
                            onClick={() => thumbnailRef?.current?.click()}
                            className={
                                'border border-line02 overflow-hidden bg-white w-[80px] h-[80px] mt-[10px] cursor-pointer text-center md:mt-0 md:w-[45px] md:h-[45px]'
                            }>
                            {thumbnail ? (
                                <WizImage src={thumbnail} />
                            ) : (
                                <Text className={'text-body_comm text-font04 leading-[75px] md:leading-[45px]'}>
                                    Thumbnail
                                </Text>
                            )}
                        </div>
                        <input
                            type={'file'}
                            onChange={e => {
                                onChangeThumbnail(e)
                            }}
                            ref={thumbnailRef}
                            className={'hidden'}
                        />
                    </div>
                    <div className={'space-y-[7px] flex-1'}>
                        <div>
                            <UnderLineInput
                                placeholder={'Title'}
                                className={'text-ti1 sm:text-ti2'}
                                onChanged={text =>
                                    dispatch({
                                        type: 'field_update',
                                        field: 'title',
                                        value: text,
                                    })
                                }
                            />
                        </div>
                        <div>
                            <UnderLineInput
                                placeholder={'Description'}
                                className={'text-body2 text-font02 sm:text-body3'}
                                onChanged={text =>
                                    dispatch({
                                        type: 'field_update',
                                        field: 'description',
                                        value: text,
                                    })
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className={'md:col-span-2 sm:col-span-1'}>
                    <Text className={'text-body3 text-font02'}>Click URL</Text>
                    <UnderLineInput
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'url',
                                value: text,
                            })
                        }
                    />
                </div>

                <div className={'flex flex-col gap-y-[15px]'}>
                    <Text className={'text-body3 text-font02'}>Background</Text>
                    <UnderLineInput
                        placeholder={'Light ex) #FFFFFF'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'background',
                                value: {...background, light: text},
                            })
                        }
                    />
                    <UnderLineInput
                        placeholder={'dark ex) #000000'}
                        onChanged={text =>
                            dispatch({
                                type: 'field_update',
                                field: 'background',
                                value: {...background, dark: text},
                            })
                        }
                    />
                </div>

                <div className={'col-span-2 text-center mt-[30px]'}>
                    <WizButton type={'blue'} size={'big'} text={'Create AD'} onClick={() => onClickCreateAD()} />
                </div>
            </div>
        </PageLayout>
    )
}

export default AdvertisementCreatePage
